import { createImageSetsFromMultidimensionalImage } from './multidimUtils';
import A from './ActionCreators.js';
import C from './Constants';

const onSuccess = ({remoteStorageResourceId,imageSpec,storageLocation,args},dispatch) => res => {

  let { _id, version, imageId } = imageSpec;
  _id = _id || imageId;

  let postData = res.json;


  dispatch(A.clearPostData({imageSpec}))

  //console.log(postData);
  let startImageUploadsArgs = args.args;

  createImageSetsFromMultidimensionalImage(
    dispatch,postData,startImageUploadsArgs
  );

  console.log("~~~~~~ IMAGE SETS CREATED!");

  dispatch(A.discardPendingRecords({
    imageIds:[_id]
  }))

  return dispatch(A.syncChanges()).then(() => {



    let failedDirectS3Post = res.status !== 204 && imageSpec.version === 'raw'
    if( failedDirectS3Post ){
      dispatch(

        A.pushNotification({
          notificationType:C.imageSyncFailure,
          args:{ imageId:_id }
        })
      )
      return;
    }



    //let remoteStorageResourceId = postData.fields.key;


    dispatch(A.setRemoteStorageResourceId({
      _id, 
      version,
      pendingRecords:false,
      storageLocation,
      remoteStorageResourceId
    }))
  })
  

}

export default onSuccess;
